<template>
  <div>
    <div class="text-h3 black--text text-no-wrap" data-cy="booking-time">{{ times }}</div>
    <div class="text-h4 black--text text-no-wrap" data-cy="booking-date">
      {{ date | capitalize }}
    </div>
  </div>
</template>

<script>
import { getDuration } from "@/_shared/lib/time";

export default {
  props: {
    from: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  computed: {
    start() {
      return this.$date.parseISO(this.from);
    },
    end() {
      return this.$date.parseISO(this.to);
    },

    times() {
      let startTime = this.$date.format(this.start, "H:mm");
      let endTime = this.$date.format(this.end, "H:mm");

      return `${startTime} - ${endTime}`;
    },

    duration() {
      return getDuration(this.$date.parseISO(this.start), this.$date.parseISO(this.end));
    },

    date() {
      return this.$date.format(this.start, "EEEE, d. MMM yyyy");
    },
  },
};
</script>
